<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>订单日志</span>
      </div>
      
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input v-model="queryParams.orderNo" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="logList">
        <el-table-column label="日志ID" align="center" prop="id" width="80" />
        <el-table-column label="订单号" align="center" prop="orderNo" width="180" />
        <el-table-column label="操作类型" align="center" prop="operationType" width="120" />
        <el-table-column label="操作内容" align="center" prop="operationContent" show-overflow-tooltip />
        <el-table-column label="操作人" align="center" prop="operator" width="120" />
        <el-table-column label="操作时间" align="center" prop="createTime" width="180" />
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'OrderLog',
  data() {
    return {
      loading: true,
      total: 0,
      logList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderNo: undefined
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      // TODO: 调用API获取订单日志列表
      setTimeout(() => {
        this.logList = []
        this.total = 0
        this.loading = false
      }, 500)
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
